import React from 'react'

const ConfirmOrder = () => {
  return (
    <div>ConfirmOrder</div>
  )
}

export default ConfirmOrder